import { randomUUID } from 'client/utils';
import { useMemo, useState } from 'react';
import { Booking, CalEventData } from '../types';

// State interface
export interface RuntimeCalBookingState {
    isLoading: boolean;
    confirmButtonDisabled: boolean;
    bookerKey: string | null;
    rescheduleUid: string | null;
    cancelBookingId: string | null;
    confirmationData: Booking | null;
    calEventData: CalEventData | null;
}

// Initial state
const initialState: RuntimeCalBookingState = {
    isLoading: true,
    confirmButtonDisabled: false,
    bookerKey: randomUUID(),
    rescheduleUid: null,
    cancelBookingId: null,
    confirmationData: null,
    calEventData: null,
};

export const useRuntimeCalBookingState = () => {
    const [state, setState] = useState<RuntimeCalBookingState>(initialState);

    const actions = useMemo(
        () => ({
            setIsLoading: (isLoading: boolean) =>
                setState(prev => ({ ...prev, isLoading })),

            setConfirmButtonDisabled: (confirmButtonDisabled: boolean) =>
                setState(prev => ({ ...prev, confirmButtonDisabled })),

            resetBookerState: () =>
                setState(prev => ({ ...prev, bookerKey: randomUUID() })),

            setRescheduleUid: (rescheduleUid: string | null) =>
                setState(prev => ({ ...prev, rescheduleUid })),

            setCancelBookingId: (cancelBookingId: string | null) =>
                setState(prev => ({ ...prev, cancelBookingId })),

            setConfirmationData: (confirmationData: Booking | null) =>
                setState(prev => ({ ...prev, confirmationData })),

            clearConfirmationData: () =>
                setState(prev => ({
                    ...prev,
                    confirmationData: null,
                    bookerKey: randomUUID(),
                })),

            onBookingSuccess: (booking: Booking) =>
                setState(prev => ({
                    ...prev,
                    rescheduleUid: null,
                    confirmationData: booking,
                    bookerKey: randomUUID(),
                })),

            setCalEventData: (calEventData: CalEventData) =>
                setState(prev => ({ ...prev, calEventData })),
        }),
        []
    );

    return [state, actions] as const;
};
